import React, { useContext, useEffect, useState } from 'react';
import { Components } from '../../styled';
import ProjectTableHeader from '../../../../components/ProjectTableHeader';
import useFormTextState from '../../../../hooks/useFormTextState';
import ProjectTable from '../../../../components/ProjectTable';
import { filteringModel, tableColumns } from '../../../../components/ProjectTable/constants';
import { ActivityIndicatorContext } from '../../../../providers/ActivityIndicatorProvider/context';
import useModalState from '../../../../hooks/useModalState';
import { LevelDefinition } from '../../../../api/types/progress';
import { deleteLevelDefinition, getAllLevelDefinitions } from '../../../../api/progress';
import CreateOrEditLevelDefinitionModal from '../../../../components/modals/CreateOrEditLevelDefinitionModal';

const LevelDefinitions = ({
  setShouldRefreshContext,
}: {
  setShouldRefreshContext: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);

  const [data, setData] = useState<LevelDefinition[]>([]);

  const searchProps = useFormTextState();

  const createLevelModalProps = useModalState<{ level?: LevelDefinition }>();

  const refreshData = async () => {
    setIsLoading(true);
    const result = await getAllLevelDefinitions();
    setIsLoading(false);
    if (result && Array.isArray(result)) {
      setData(result);
    }
  };

  useEffect(() => {
    refreshData().then();
  }, []);

  const onAddLevel = () => {
    createLevelModalProps.open({ level: undefined });
  };
  const onEditLevel = (id: string) => {
    const foundLevel = data?.find((item) => item?.id === id);
    if (foundLevel) {
      createLevelModalProps.open({ level: foundLevel });
    }
  };

  const onDeleteLevel = async (id: string) => {
    setIsLoading(true);
    await deleteLevelDefinition(id);
    setIsLoading(false);
    await refreshData();
  };

  const onCreateOrEditModalClose = (refreshTrigger?: boolean) => {
    if (refreshTrigger) {
      refreshData?.().then();
      setShouldRefreshContext(true);
    }
    createLevelModalProps.onModalClose();
  };

  const _filteringModel = filteringModel([
    { columnField: 'searchValue', value: searchProps.value, operatorValue: 'contains' },
  ]);
  return (
    <Components.ComponentContainer>
      <ProjectTableHeader
        onSearchChange={searchProps.onChangeText}
        searchLabel={'Search by level title or ID'}
        searchPlaceholder={'Enter search term'}>
        <Components.SearchBarSeparator />
        <Components.PrimaryButton onClick={onAddLevel}>Add Level</Components.PrimaryButton>
      </ProjectTableHeader>
      <Components.TableWrapper>
        <ProjectTable
          data={data || []}
          columns={tableColumns.levelDefinitions({ onEdit: onEditLevel, onDelete: onDeleteLevel })}
          filteringModel={_filteringModel}
          showRowCountText={'Found levels'}
          customPageSize={15}
          sortingModel={{ field: 'level', sort: 'asc' }}
        />
      </Components.TableWrapper>
      <CreateOrEditLevelDefinitionModal
        {...createLevelModalProps}
        onModalClose={onCreateOrEditModalClose}
        refreshCallback={refreshData}
      />
    </Components.ComponentContainer>
  );
};

export default LevelDefinitions;
